"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _draftJs = require("draft-js");

var _lodash = _interopRequireDefault(require("lodash"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _reactDraftWysiwygStyles = _interopRequireDefault(require("./react-draft-wysiwyg-styles"));

var _libphonenumberJs = require("libphonenumber-js");

var _linkifyIt = _interopRequireDefault(require("linkify-it"));

var _flattenObject = _interopRequireDefault(require("../../../utils/flatten-object"));

var _Placeholders = _interopRequireDefault(require("../../../controls/Placeholders"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var linkify = (0, _linkifyIt["default"])();
linkify.add("tel:", {
  validate: function validate(text, pos, self) {
    var tail = text.slice(pos);
    var phoneNumber = (0, _libphonenumberJs.parsePhoneNumberFromString)(tail, "US");

    if (phoneNumber) {
      return phoneNumber.number.length;
    }

    return 0;
  }
});

var linkCallback = function linkCallback(params) {
  var links = linkify.match(params.target);
  return _objectSpread(_objectSpread({}, params), {}, {
    target: links && links[0] && links[0].url || params.target
  });
};

var TextEditor = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TextEditor, _Component);

  var _super = _createSuper(TextEditor);

  function TextEditor(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, TextEditor);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyCommand", function (command, editorState) {
      var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);

      if (newState) {
        _this.onEditorStateChange(newState);

        return "handled";
      }

      return "not-handled";
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "convertUserInput", function (editorState) {
      return (0, _draftJs.convertToRaw)(editorState.getCurrentContent());
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function () {
      _this.updateFormValue();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadDynamic", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.state.Editor === null)) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require("react-draft-wysiwyg"));
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
              return _context.abrupt("return", null);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = {
      Editor: null,
      editorState: props.field && props.field.value ? _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(props.field.value)) : _draftJs.EditorState.createEmpty()
    };

    _this.onEditorStateChange = function (editorState) {
      _this.setState({
        editorState: editorState
      });

      _this.updateFormValue(editorState);
    };

    _this.handleKeyCommand = _this.handleKeyCommand.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(TextEditor, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.editingContentId !== this.props.editingContentId && this.props.field && this.props.field.value) {
        this.setState({
          editorState: _draftJs.EditorState.createWithContent((0, _draftJs.convertFromRaw)(this.props.field.value))
        });
      }
    }
  }, {
    key: "updateFormValue",
    value: function updateFormValue() {
      var editorState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.editorState;
      var value = this.convertUserInput(editorState);
      return this.props.form.setFieldValue(this.props.field.name, value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          placeholders = _this$props.placeholders;
      var _this$state = this.state,
          editorState = _this$state.editorState,
          Editor = _this$state.Editor;
      this.loadDynamic().then(function (module) {
        if (module !== null) {
          _this2.setState({
            Editor: module.Editor
          });
        }
      });

      var options = _lodash["default"].map((0, _flattenObject["default"])(placeholders), function (label, key) {
        return {
          key: key,
          label: label
        };
      });

      if (Editor) {
        return /*#__PURE__*/_react["default"].createElement(Editor, {
          editorState: editorState,
          onEditorStateChange: this.onEditorStateChange,
          toolbar: {
            options: ["inline", "fontFamily", "fontSize", "blockType", "list", "textAlign", "link", "embedded", "emoji", "remove", "history"],
            inline: {
              options: ["bold", "italic", "underline", "strikethrough"]
            },
            blockType: {
              options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6", "Blockquote"]
            },
            embedded: {
              popupClassName: classes.optionModal
            },
            link: {
              linkCallback: linkCallback
            }
          },
          toolbarCustomButtons: options.length ? [/*#__PURE__*/_react["default"].createElement(_Placeholders["default"], {
            options: options
          })] : undefined
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Loading...");
    }
  }]);
  return TextEditor;
}(_react.Component);

var styles = function styles() {
  return _objectSpread(_objectSpread({}, _reactDraftWysiwygStyles["default"]), {}, {
    optionModal: {
      left: "unset",
      right: 0
    }
  });
};

var _default = (0, _withStyles["default"])(styles)(TextEditor);

exports["default"] = _default;